import React, { useContext, useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { IoBagHandleOutline } from "react-icons/io5";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import PostApiCall from "../helper/PostAPI";
import Notiflix from "notiflix";
import { store } from "../Home/Pages/Store/Store";
import ModifyQuantity from "../../Buttons/ModifyQuantity";
import NewAddTocart from "../../Buttons/NewAddTocart";
import { newstore } from "../Home/Pages/Store/newStore";
import { NewCart } from "../../NewCartPage/NewCart";
import GetSeoData from "../../Helpers/GetSeoData";

function ProductDetail() {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [product, setProduct] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [addedItems, setAddedItems] = useState(new Set());

  const { cartItems } =
    useContext(newstore);
  const { route } = useParams();
  const [isInCart, setIsInCart] = useState([]);
  const [cart, setCart] = useState(
    JSON.parse(localStorage.getItem("cart")) || []
  );
  const recentProducts = [...products]
    .sort((a, b) => new Date(b.FLD_Updated_on) - new Date(a.FLD_Updated_on))
    .slice(0, 4);

  useEffect(() => {
    window.scroll({
      top: 0, // Calculate the absolute position of the filtered items
      behavior: "smooth",
    });
  }, [route])

  useEffect(() => {

    if (route) {

      PostApiCall.postRequest(
        { route: route },
        // { id: id },
        // { WhereClause: `where FLD_Item_ID = ${id}` },
        "GetProductByVariant"
      )
        .then((res) => res.json())
        .then((resData) => {
          if (resData?.data?.length > 0) {
            setProduct(resData.data[0]);
            const InCart = cartItems.find((item) => {
              if (parseInt(item.fld_variantid) == resData.data[0]?.fld_variantid) {
                return item;
              }
              return false;
            });

            setIsInCart(InCart);
            const existing = cart.find(
              (item) => item.FLD_Item_ID === resData.data[0].FLD_Item_ID
            );
            if (existing) {
              setQuantity(existing.quantity);
            }
          }
        });
    }

  }, [cartItems, route]);

  useEffect(() => {


    PostApiCall.postRequest({
      stateid: null,
    },
      "Get_All_Items")
      // PostApiCall.postRequest({}, "GetAllItems")
      .then((res) => res.json())
      .then((resData) => {
        if (resData?.data?.length > 0) {
          setProducts(resData.data);
        }
      });
  }, [])

  useEffect(() => {
    localStorage.setItem("cart", JSON.stringify(cart));
  }, [cart]);


  const handleAddprod = (item) => {
    setAddedItems((prev) => new Set(prev).add(item.FLD_Item_ID));
    setTimeout(() => {
      setAddedItems((prev) => {
        const updated = new Set(prev);
        updated.delete(item.FLD_Item_ID);
        return updated;
      });
    }, 3000);
  };

  return (
    <div className="container my-5 blogcontainer">
      <GetSeoData type="Variant" route={route} />
      <div className="row">
        <div className="col-md-4">
          <img
            src={product?.VariantImage}
            alt={product?.fld_itemname}
            className="img-fluid rounded"
          />
        </div>
        <div className="col-md-8">
          <h2>{product?.fld_itemname}</h2>
          <p className="text-muted">{product?.fld_categoryname}</p>
          <h4 style={{ fontWeight: 600, color: "#0C0C0C" }}>
            ₹{product?.fld_website_discount_price}
          </h4>

          {/* <div className="py-3">
            {product?.fld_short_description || "No description available."}
          </div> */}
          <div className="py-3" dangerouslySetInnerHTML={{
            __html: product?.fld_short_description || "",
          }}
          />

          <div className="my-3 detail-add-button">
            {isInCart ? (
              <ModifyQuantity
                itemid={product?.fld_variantid}
                quantity={isInCart.fld_quantity}
                cartlineid={isInCart.fld_cart_dtl_id}
              />
            ) : (
              <span className="theme-btn cursor-pointer">
                <NewAddTocart itemid={product?.fld_variantid} />
              </span>
            )}
          </div>

          <p className="py-2">
            <span className="fw-bold">Food Type:</span> {product?.fld_categoryname}
          </p>
          {/* <p className="py-2">
            <span className="fw-bold">Best Seller:</span>{" "}
            {product?.FLD_Best_Seller}
          </p> */}
        </div>
      </div>

      <div className="row pt-5">
        <div className="col-md-12">
          <h4
            className="fw-bold py-3 text-decoration-underline"
            style={{ textDecorationColor: "green" }}
          >
            Descriptions
          </h4>
          <div
            dangerouslySetInnerHTML={{
              __html: product?.fld_long_description || "",
            }}
          />
        </div>
      </div>

      <Container className="my-5 blogcontainer">
        <Row className="blogcard">
          <h3>Related Products</h3>
          {recentProducts.map((item, index) => {
            const isCart = cartItems.find((val) => {
              if (val.fld_variantid === item.fld_variantid) {
                return item;
              }
              return false;
            });
            return (
              <Col xs={12} md={3} key={index} className="mt-3">
                <Card>
                  <Link to={`/product/${item.fld_route}`}>
                    <Card.Img variant="top" src={item.VariantImage} />
                  </Link>
                  <Card.Body>
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <Card.Title className="mb-0">{item.fld_variantname}</Card.Title>
                    </div>
                    <Card.Text><div className="d-flex align-items-center justify-content-between">₹{item.fld_website_discount_price}
                      {isCart ? (
                        <ModifyQuantity
                          itemid={item?.fld_variantid}
                          quantity={isCart.fld_quantity}
                          cartlineid={isCart.fld_cart_dtl_id}
                        />
                      ) : (
                        <span className="theme-btn cursor-pointer">
                          <NewAddTocart itemid={item?.fld_variantid} />
                        </span>
                      )}
                    </div>
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            )
          })}
        </Row>
      </Container>
      <section className="fixed-bottom mb-0 ms-auto px-2">
        <div>
          <>
            <div className="d-flex flex-wrap flex-lg-nowrap justify-content-end align-items-center py-2">

              {cartItems?.length > 0 && (
                <Button
                  variant="danger"
                  size="lg"
                  className={
                    cartItems?.length > 0
                      ? "floating-button-cart floating-button-cart-btn d-flex"
                      : "floating-button-cart d-flex"
                  }
                  onClick={() => {
                    navigate('/cart')
                  }}
                >
                  <div>
                    <p className="mb-0 total-item-amount d-flex">
                      {cartItems?.length} Item
                      <span
                        style={{ display: cartItems?.length == 1 ? "none" : "block" }}
                      >
                        (s)
                      </span>
                      &nbsp; | ₹ {cartItems[0]?.fld_cart_amount_no_shipping} Plus Taxes
                    </p>
                  </div>
                </Button>
              )}
            </div>
          </>
        </div>
      </section>
    </div>

    
  );
}

export default ProductDetail;
